import { render, staticRenderFns } from "./RegisterPersonalDataStep.vue?vue&type=template&id=312d600f"
import script from "./RegisterPersonalDataStep.vue?vue&type=script&lang=js"
export * from "./RegisterPersonalDataStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports